import { render, staticRenderFns } from "./MainLedgerIndex4.vue?vue&type=template&id=8fedb0ac&scoped=true"
import script from "./MainLedgerIndex4.vue?vue&type=script&lang=js"
export * from "./MainLedgerIndex4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fedb0ac",
  null
  
)

export default component.exports